import { render, staticRenderFns } from "./FailedMedications.vue?vue&type=template&id=66948073&scoped=true&"
import script from "./FailedMedications.vue?vue&type=script&lang=js&"
export * from "./FailedMedications.vue?vue&type=script&lang=js&"
import style0 from "./FailedMedications.vue?vue&type=style&index=0&id=66948073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66948073",
  null
  
)

export default component.exports